import { NavLink } from 'react-router-dom';
import { useAuth } from '../stores/auth';

export function BottomNav() {
  const auth = useAuth();
  const role = auth.user?.role;
  const hasWorkshop = !!auth.activeWorkshop;

  if (role === 'CUSTOMER') {
    return (
      <nav className="bottom-nav">
        <NavLink to="/" end>
          <span className="icon">🏠</span>
          <span>Bosh</span>
        </NavLink>
        <NavLink to="/marketplace">
          <span className="icon">🔍</span>
          <span>Qidirish</span>
        </NavLink>
        <NavLink to="/my-bookings">
          <span className="icon">📅</span>
          <span>Bandlar</span>
        </NavLink>
        <NavLink to="/my-orders">
          <span className="icon">📋</span>
          <span>Buyurtmalar</span>
        </NavLink>
        <NavLink to="/my-cars">
          <span className="icon">🚗</span>
          <span>Mashinalar</span>
        </NavLink>
        <NavLink to="/settings">
          <span className="icon">⚙️</span>
          <span>Sozlama</span>
        </NavLink>
      </nav>
    );
  }

  return (
    <nav className="bottom-nav">
      <NavLink to="/" end>
        <span className="icon">📊</span>
        <span>Bugun</span>
      </NavLink>
      {hasWorkshop && (
        <NavLink to="/orders">
          <span className="icon">📋</span>
          <span>Buyurtmalar</span>
        </NavLink>
      )}
      <NavLink to="/workshops">
        <span className="icon">🏢</span>
        <span>Ustalar</span>
      </NavLink>
      {hasWorkshop && (
        <NavLink to="/stats">
          <span className="icon">📈</span>
          <span>Stat</span>
        </NavLink>
      )}
      <NavLink to="/settings">
        <span className="icon">⚙️</span>
        <span>Sozlama</span>
      </NavLink>
    </nav>
  );
}
